import { createContext, useContext, useRef } from 'react';
import { useViewportVisibility } from '@/hooks/useViewportVisibility';

export interface ViewportState {
  isInView: boolean;
  hasEntered: boolean;
}

const ViewPortStateContext = createContext<ViewportState | null>(null);

export const ViewportStateProvider: React.FC<{ children: React.ReactNode; className: string }> = ({
  children,
  className
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const state = useViewportVisibility(ref);

  return (
    <ViewPortStateContext.Provider value={state}>
      <div className={className} ref={ref}>
        {children}
      </div>
    </ViewPortStateContext.Provider>
  );
};

export const useViewportState = (): ViewportState => {
  const state = useContext(ViewPortStateContext);
  if (state === null) {
    throw new Error('useViewportState must be used within a ViewportStateProvider');
  }
  return state;
};
